import React from "react";
import classnames from "classnames";
import { makeStyles } from "@mui/styles"; // adjust if needed
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import { LOGIC_HELPERS } from "utils/helpers/logic";
import styles from "./styles";

const useStyles = makeStyles(styles);

const JText = ({
    component: Component = "span",
    children,
    className,
    ellipsis,
    ellipsis2,
    xs,
    sm,
    md,
    lg,
    xlg,
    xl,
    xxl,
    xxxl,
    gray,
    lightGray,
    darkGray,
    darkSuccess,
    blue,
    darkBlue,
    orange,
    darkgreen,
    danger,
    white,
    success,
    black,
    dark,
    regular,
    bold,
    bolder,
    bold700,
    italic,
    halfPaddingLeft,
    paddingRight,
    halfPaddingRight,
    link,
    underline,
    textCenter,
    textLeft,
    textRight,
    uppercase,
    lowercase,
    capitalize,
    nowrap,
    spacing2,
    spacing4,
    onClick,
    noUnderlined,
    placeholder,
    warning,
    light,
    icon,
    hoverOrange,
    lineThrough,
    primary,
    paddingLeft,
    ...props
}) => {
    const classes = useStyles();

    const rendered = (
        <Component
            className={classnames(
                classes.root,
                LOGIC_HELPERS.ifElse(
                    link,
                    classnames(classes.blue, classes.link)
                ),
                LOGIC_HELPERS.ifElse(
                    underline,
                    classnames(classes.blue, classes.underline)
                ),
                LOGIC_HELPERS.ifElse(ellipsis, "j-text-ellipsis"),
                LOGIC_HELPERS.ifElse(ellipsis2, "j-text-ellipsis2"),
                LOGIC_HELPERS.ifElse(regular, classes.regular),
                LOGIC_HELPERS.ifElse(bold, classes.bold),
                LOGIC_HELPERS.ifElse(bolder, classes.bolder),
                LOGIC_HELPERS.ifElse(bold700, classes.bold700),
                LOGIC_HELPERS.ifElse(italic, classes.italic),
                LOGIC_HELPERS.ifElse(xs, classes.xs),
                LOGIC_HELPERS.ifElse(sm, classes.sm),
                LOGIC_HELPERS.ifElse(md, classes.md),
                LOGIC_HELPERS.ifElse(lg, classes.lg),
                LOGIC_HELPERS.ifElse(xlg, classes.xlg),
                LOGIC_HELPERS.ifElse(xl, classes.xl),
                LOGIC_HELPERS.ifElse(xxl, classes.xxl),
                LOGIC_HELPERS.ifElse(xxxl, classes.xxxl),
                LOGIC_HELPERS.ifElse(gray, classes.gray),
                LOGIC_HELPERS.ifElse(primary, classes.primary),
                LOGIC_HELPERS.ifElse(lightGray, classes.lightGray),
                LOGIC_HELPERS.ifElse(darkGray, classes.darkGray),
                LOGIC_HELPERS.ifElse(darkSuccess, classes.darkSuccess),
                LOGIC_HELPERS.ifElse(blue, classes.blue),
                LOGIC_HELPERS.ifElse(darkBlue, classes.darkBlue),
                LOGIC_HELPERS.ifElse(orange, classes.orange),
                LOGIC_HELPERS.ifElse(hoverOrange, classes.hoverOrange),
                LOGIC_HELPERS.ifElse(darkgreen, classes.darkgreen),
                LOGIC_HELPERS.ifElse(black, classes.black),
                LOGIC_HELPERS.ifElse(dark, classes.black),
                LOGIC_HELPERS.ifElse(danger, classes.danger),
                LOGIC_HELPERS.ifElse(white, classes.white),
                LOGIC_HELPERS.ifElse(success, classes.success),
                LOGIC_HELPERS.ifElse(placeholder, classes.placeholder),
                LOGIC_HELPERS.ifElse(paddingLeft, classes.paddingLeft),
                LOGIC_HELPERS.ifElse(halfPaddingLeft, classes.halfPaddingLeft),
                LOGIC_HELPERS.ifElse(paddingRight, classes.paddingRight),
                LOGIC_HELPERS.ifElse(
                    halfPaddingRight,
                    classes.halfPaddingRight
                ),
                LOGIC_HELPERS.ifElse(
                    [!ellipsis, !ellipsis2, nowrap],
                    classes.nowrap
                ),
                LOGIC_HELPERS.ifElse(textCenter, classes.textCenter),
                LOGIC_HELPERS.ifElse(textLeft, classes.textLeft),
                LOGIC_HELPERS.ifElse(textRight, classes.textRight),
                LOGIC_HELPERS.ifElse(uppercase, classes.uppercase),
                LOGIC_HELPERS.ifElse(lowercase, classes.lowercase),
                LOGIC_HELPERS.ifElse(capitalize, classes.capitalize),
                LOGIC_HELPERS.ifElse(spacing2, classes.spacing2),
                LOGIC_HELPERS.ifElse(spacing4, classes.spacing4),
                LOGIC_HELPERS.ifElse(onClick, classes.onClick),
                LOGIC_HELPERS.ifElse(noUnderlined, classes.noUnderlined),
                LOGIC_HELPERS.ifElse(warning, classes.warning),
                LOGIC_HELPERS.ifElse(light, classes.light),
                LOGIC_HELPERS.ifElse(lineThrough, classes.lineThrough),
                className
            )}
            title={LOGIC_HELPERS.ifElse(
                ellipsis,
                LOGIC_HELPERS.ifElse(typeof children !== "object", children)
            )}
            onClick={onClick}
            {...props}
        >
            {children}
        </Component>
    );

    if (!icon) return rendered;

    let iconSize = "small";
    if (xs) iconSize = "xxsmall";
    else if (sm) iconSize = "xsmall";
    else if (md) iconSize = "small";
    else if (lg || xlg) iconSize = "normal";
    else if (xl) iconSize = "medium";
    else if (xxl) iconSize = "mediumPlus";

    return (
        <GridContainer alignItems="baseline" spacing={0} wrap="nowrap">
            <GridItem>{rendered}</GridItem>
        </GridContainer>
    );
};

JText.defaultProps = {
    component: "span"
};

export default JText;
